<ng-container *ngIf="device.isMobile; else desktop">
     <img class="image-preview-mobile" [src]="url" (error)="imageError($event)" (load)="imageReady($event)" />
</ng-container>
<ng-template #desktop>
    <div 
        [appBackgroundImage]="url"
        maxRetry="2"
        (imageLoadError)="imageError($event)"
        (readyToDisplayImage)="imageReady($event)" 
        [ngClass]="{'image-container-thumbnail': type === 'thumbnail', 'image-container-modal-preview': type === 'preview'}" @pageAnimation>
    </div>
</ng-template>
<app-smash-loading-spinner type="loading-spinner" *ngIf="!imageIsReady" class="image-loading-spinner"></app-smash-loading-spinner>
